import {useState, useMemo, useEffect} from 'react';
import './App.scss';

import {ConfigProvider, theme} from 'antd';
import {ColorModeContext} from 'Helpers/contexts';
import {UserContextProvider} from 'Hooks/UserContext';
import AppLayout from 'Components/Shared/AppLayout';
import {QueryClient, QueryClientProvider} from 'react-query';
import {ServicesProvider} from 'Hooks/ServicesContext';
import {SnackbarProvider} from 'notistack';
import {extractTokenDetails, getDesignTokens} from 'Helpers/ats.helper';
import {ThemeProvider} from './ThemeProvider';
import {useNavigate} from 'react-router-dom';
import {Paths} from 'Router/Paths';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 0,
			cacheTime: 0,
			retry: false,
			refetchOnWindowFocus: false,
		},
	},
});

function App() {
	const navigate = useNavigate();
	/* Theme mod configuration */
	const [mode, setMode] = useState(() => {
		const storedMode = localStorage.getItem('mode');
		return storedMode ? JSON.parse(storedMode) : true;
	});

	// Save mode value to localStorage whenever it changes
	useEffect(() => {
		localStorage.setItem('mode', JSON.stringify(mode));
	}, [mode]);

	const colorMode = useMemo(
		() => ({
			// The dark mode switch would invoke this method
			toggleColorMode: () => {
				setMode(prevMode => !prevMode);
			},
		}),
		[]
	);

	// Immediate authentication check on initial app mount / full page reload
	useEffect(() => {
		const checkAuth = () => {
			const token = localStorage.getItem('Authorization');

			if (!token) {
				// No token → show login
				return;
			}

			const userDetails = extractTokenDetails(token);
			const currentTime = Math.floor(Date.now() / 1000);

			// Validate expiration; clear state and redirect if token is no longer valid
			if (!userDetails || userDetails.exp < currentTime) {
				localStorage.clear();
				if (window.location.pathname != Paths.base) {
					navigate(Paths.base, {replace: true});
				}
				return;
			}
		};

		checkAuth();
	}, [navigate]);
	return (
		<>
			<ConfigProvider theme={getDesignTokens(mode, theme)}>
				<ThemeProvider theme={getDesignTokens(mode, theme)}>
					<QueryClientProvider client={queryClient}>
						<ColorModeContext.Provider value={{colorMode, mode}}>
							{/* <ThemeProvider theme={theme}> */}
							<SnackbarProvider autoHideDuration={2500} maxSnack={1}>
								<UserContextProvider>
									<ServicesProvider>
										{/* <CssBaseline /> */}
										<div className={'appContainer ' + mode ? 'light' : 'dark'}>
											<AppLayout />
										</div>
									</ServicesProvider>
								</UserContextProvider>
							</SnackbarProvider>
							{/* </ThemeProvider> */}
						</ColorModeContext.Provider>
					</QueryClientProvider>
				</ThemeProvider>
			</ConfigProvider>
		</>
	);
}

export default App;
